import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export interface MfaFactor {
  id: string;
  friendly_name?: string;
  factor_type: "totp";
  status: "verified" | "unverified";
  created_at: string;
  updated_at: string;
}

export function useMfaFactors(userId: string | null) {
  const query = useQuery({
    queryKey: ["mfa", "factors", userId],
    queryFn: async () => {
      const { data, error } = await supabase.auth.mfa.listFactors();
      if (error) throw error;
      return (data.totp ?? []) as MfaFactor[];
    },
    enabled: !!userId,
    staleTime: 30_000,
  });

  const verifiedFactors = query.data?.filter((f) => f.status === "verified") ?? [];

  return {
    factors: query.data ?? [],
    verifiedFactors,
    hasVerifiedFactor: verifiedFactors.length > 0,
    isLoading: query.isLoading,
    refetch: query.refetch,
  };
}
